import PageHeader from "../components/PageHeader";
import CTABanner from "../components/CTABanner";
import FAQ from "../components/FAQ";
import { Reveal } from "../components/motion";
import useMeta from "../lib/useMeta";
import { breadcrumb } from "../lib/seo";
import { FAQS } from "../lib/site";

const FAQ_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQS.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function FAQPage() {
  useMeta({
    title: "Procurement & Operations FAQs | Saarthva Ventures",
    description: "Find answers about Saarthva's procurement, sourcing, delivery, vendor management, operations support and service coverage.",
    path: "/faq",
    schemas: [breadcrumb("FAQs", "/faq"), FAQ_SCHEMA],
  });
  return (
    <div data-testid="faq-page">
      <PageHeader
        eyebrow="FREQUENTLY ASKED QUESTIONS"
        title="Questions,"
        accent="answered."
        description="Everything businesses usually ask before starting with Saarthva — and the honest answers."
      />
      <section className="bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
          <Reveal>
            <FAQ />
          </Reveal>
        </div>
      </section>
      <CTABanner />
    </div>
  );
}
